import { HIDE_MESSAGE } from './actionTypes';

export const clearError = (type) => ({
  type: HIDE_MESSAGE,
  payload: type,
});
